<template lang="html">
<section v-if="issuesByLetter.length > 0">
  <div class="container">
    <div class="column is-10-tablet is-offset-1-tablet is-8-widescreen is-offset-2-widescreen">
      <div class="content" v-for="issues in issuesByLetter" >
        <h4 style="margin-top: 44px;" v-if="issues.issues.length > 0">{{issues.letter}}</h4>
          <div class="IssueList-item" v-for="issue in issues.issues" :key="issue.title">
            <router-link class="IssueList-link" :to="getSlug(issue)">{{issue.title}}</router-link>
          </div>
        </ul>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import sanityQuery from '@/sanityQuery'

export default {
  data () {
    return {
      issuesByLetter: []
    }
  },
  created () {
    var query = `*[_type == "issue" && !(_id in path "drafts.**")][0...500] | order(title asc){title, slug{current}, "redirect": redirect->{title, slug}}`
    sanityQuery(query).then(result => {
      // Sorting from Sanity does not account for ÆØÅ we need to sort it manually
      var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWZÆØÅ'.split('')
      for (var letter of alphabet) {
        var letterObj = {}
        letterObj.issues = []
        letterObj.letter = letter
        for (const issue of result) {
          if (issue.title.charAt(0) === letter) {
            letterObj.issues.push(issue)
          }
        }
        this.issuesByLetter.push(letterObj)
      }
    })
  },
  methods: {
    getSlug (issue) {
      if (issue.redirect) {
        return issue.redirect.slug.current
      } else {
        return issue.slug.current
      }
    }
  }
}
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/IssueList.vue